import { IdleQueue } from 'idlize/IdleQueue';
/* Class that represents the redux beacon target to track Segment events */
class Segment {
  constructor() {
    this.events = [];
    this.queue = new IdleQueue({ ensureTasksRun: true });

    this.target = (events) => {
      this.startTime = this.startTime || +new Date();
      this.events = [...this.events, ...events];
      this.queue.pushTask(this.trackEvent.bind(this));
    };

    this.hitTypeHandlers = {
      identify: (event) => window.analytics.identify(event.userId, event.traits, event.options),
      group: (event) => window.analytics.group(event.groupId, event.traits, event.options),
      pageview: (event) => window.analytics.page(event.page, event.name, event.properties, event.options),
      event: (event) => window.analytics.track(event.eventAction, event.properties, event.options),
      alias: (event) => window.analytics.alias(event.userId, event.previousId, event.options),
      reset: () => window.analytics.reset(),
    };
  }

  trackEvent() {
    const timeLapsed = +new Date() - this.startTime;
    const isTimeExpired = timeLapsed < 15000;

    /* If analytics is not defined and the time has not expired we shouldnt queue the event again */
    if (!window.analytics && isTimeExpired) {
      this.queue.pushTask(this.trackEvent.bind(this));
      return;
    }

    /* The event is not in queue anymore because the time has passed BUT the we need to continue to 
      validate analytics */
    if (!window.analytics) {
      this.events = [];
      return;
    }

    while (this.events.length !== 0) {
      const event = this.events.shift();
      const handler = this.hitTypeHandlers[event.hitType];
      if (handler) {
        handler(event);
      }
    }

    this.startTime = +new Date();
  }

  getTarget() {
    return this.target;
  }
}

export default Segment;
